"use client";

import type { ReactNode } from "react";
import posthog from "posthog-js";
import { DiscordIcon } from "@/components/icons/DiscordIcon";
import { DISCORD_INVITE_URL } from "@/lib/community";
import { cn } from "@/lib/utils";

interface DiscordInviteLinkProps {
  /** Where the click came from — used as a PostHog event property. */
  source: string;
  label?: string;
  children?: ReactNode;
  className?: string;
  iconClassName?: string;
  showIcon?: boolean;
  /** Set to render an icon-only link (no visible label). */
  iconOnly?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
}

export function DiscordInviteLink({
  source,
  label,
  children,
  className,
  iconClassName = "size-4",
  showIcon = true,
  iconOnly = false,
  ariaLabel,
  onClick,
}: DiscordInviteLinkProps) {
  return (
    <a
      href={DISCORD_INVITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel ?? label ?? "Join our Discord community"}
      onClick={() => {
        posthog.capture("discord_invite_clicked", { source });
        onClick?.();
      }}
      className={cn(
        "inline-flex items-center gap-2 transition-colors",
        className,
      )}
    >
      {showIcon && <DiscordIcon className={iconClassName} />}
      {!iconOnly && (children ?? label)}
    </a>
  );
}
